export enum ClockType {
    'STOPWATCH' = 'STOPWATCH',
    'TIMER' = 'TIMER',
    'TIMEOUT' = 'TIMEOUT',
}
